import { ReactElement } from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditOffIcon from '@mui/icons-material/EditOff';

// Picking and zooming both start with a click on the plot, so picking is
// something the user turns on rather than the default on a channel with points
export const PickingToggle = ({
    adding,
    onToggle,
    addLabel,
    stopLabel = 'Stop adding',
    icon,
}: {
    adding: boolean;
    onToggle: () => void;
    addLabel: string;
    stopLabel?: string;
    icon?: ReactElement;
}) => (
    <Button
        variant={adding ? 'contained' : 'outlined'}
        size="small"
        color={adding ? 'warning' : 'primary'}
        startIcon={adding ? <EditOffIcon /> : icon ?? <AddIcon />}
        onClick={onToggle}
    >
        {adding ? stopLabel : addLabel}
    </Button>
);

export default PickingToggle;
